import React, { useContext, useEffect, useState } from "react";

import "./index.scss";
import * as Yup from "yup";
import Select from "react-select";

import { addCategorie } from "../../services/post-add-categorie";
import { toast } from "react-toastify";
import { UserContext } from "../context/userContext";
import { ErrorMessage, Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { log } from "console";
const initialValue = {
  name: "",
};
function ModalCategorie({
  closeModal,
  doGetCategories,
  doAdd,
  addType,
  categoriesData,
  setSelectedOption,
  selectedOption,
  categorieToEdit,
  setCategoryToEdit = (any) => {},
  doUpdateCategorie = (any) => {},
}) {
  const { user } = useContext(UserContext);

  const [initialValues, setInitialeValues] = useState(initialValue);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const validationSchema = Yup.object({
    name: Yup.string().required("name is required"),
  });
  const handleOptionSelectToStore = (option: any): void => {
    setSelectedOption(option);
  };

  const filteredOptions = categoriesData.map((category) => ({
    label: category.categoryName,
    value: category._id,
  }));

  useEffect(() => {
    if (addType == "subCategorie") {
      if (Boolean(categorieToEdit)) {
        setInitialeValues({ name: categorieToEdit?.name });
      } else {
        setInitialeValues({ name: "" });
      }
    } else {
      if (Boolean(categorieToEdit)) {
        setInitialeValues({ name: categorieToEdit?.categoryName });
      } else {
        setInitialeValues({ name: "" });
      }
    }

    return () => {
      setInitialeValues({ name: "" });
      setCategoryToEdit(null);
    };
  }, []);

  return (
    <div className="modal-categorie-container">
      <div className="modal-categorie-header">
        <h3>
          {Boolean(categorieToEdit) ? "Update" : "Ajouter"} {addType}
        </h3>
        <i
          className="bx bx-x"
          style={{ fontSize: 28 }}
          onClick={() => closeModal()}
        ></i>
      </div>

      <Formik
        initialValues={initialValues}
        enableReinitialize // This will reset the form when initialValues change
        validationSchema={validationSchema}
        onSubmit={Boolean(categorieToEdit) ? doUpdateCategorie : doAdd}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form className="modal-categorie-form">
            <div className="modal-categorie-body">
              <div className="field">
                <label htmlFor="name">{addType} name</label>
                <input
                  id="name"
                  type="text"
                  name="name"
                  placeholder={addType + " name"}
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <ErrorMessage name="name" component="div" className="error" />
              </div>

              {addType == "subCategorie" && (
                <div className="field">
                  <label>Parent category</label>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    placeholder="ex: iphone"
                    options={filteredOptions}
                    value={selectedOption}
                    onChange={handleOptionSelectToStore}
                  />
                </div>
              )}
            </div>
            <div className="modal-categorie-footer">
              <button
                type="button"
                className="btn-cancel"
                onClick={() => closeModal()}
              >
                Annuler
              </button>
              <button
                disabled={
                  addType == "subCategorie" && !Boolean(selectedOption)
                    ? true
                    : false
                }
                className="btn-save"
                type="submit"
              >
                Enregistrer
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default ModalCategorie;
